import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="container footer bg-light">
      <div className="container mt-3">
        <div className="row">
          {/* Contact Us Section */}
          <div className="col-md-4 col-sm-6 footer-contact mt-3">
            <h5>Location</h5>
            <p>29, Mothilal street, T. nagar, Chennai, Tamil Nadu 600 017.</p>

          </div>

          {/* Quick Links Section */}
          <div className="col-6 col-md-4 footer-links mt-3">
            <h5>Quick links</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/Privacy/Policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/Terms/Conditions">Term & Condition</Link>
              </li>
              <li>
                <Link to="/Faq/faq">FAQs</Link>
              </li>
              <li>
                <Link to="/contactus">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Company Section */}
          <div className="col-6 col-md-4 footer-company mt-3">
            <h5>Pages</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/3">Sale</Link>
              </li>
              <li>
                <Link to="/4">Shop</Link>
              </li>
              <li>
                <Link to="/7">Discount</Link>
              </li>
            </ul>
          </div>

          {/* Business Section */}
          {/* <div className="col-md-3 col-sm-6 footer-business mt-3">
            <h5>Get In Touch</h5>
            <ul className="list-unstyled">
              <li>
                <p>
                  <Link
                    to="mailto:sales@Kalanjiyam.com"
                    className="footer-email"
                  >
                    contact@Kalanjiyam.com
                  </Link>
                </p>
              </li>
              <li>
                <p>
                  <Link
                    to="mailto:sales@Kalanjiyam.com"
                    className="footer-email"
                  >
                    sales@Kalanjiyam.com
                  </Link>
                </p>
              </li>
              <li>
                <p>
                  <Link to="tel:1800979769" className="footer-phone">
                    +91 9998887774
                  </Link>
                </p>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;